export default "__VITE_PUBLIC_ASSET__193cc2d8__"